import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { ProjectionScreenReport } from "../../../../../service/report";
import { useHistory } from "react-router-dom";

interface ResourceProps {
    resourceData: ProjectionScreenReport;
}

export default function Resource({ resourceData }: ResourceProps) {
    const history = useHistory();
    const [count, setCount] = useState(0);
    const { courseWareCount, topicCount, chapterCount } = resourceData;

    useEffect(() => {
        setCount(courseWareCount + chapterCount);
    }, [resourceData]);

    function isMatch(path: string) {
        return history.location.pathname.indexOf(path) !== -1;
    }

    return (
        <div className={style.root}>
            <div className={style.resource}>
                <div className={style.subtitle}>课程资源（{count}）</div>
                <div className={style.container}>
                    {/*{isMatch("/analyse") && (*/}
                    {/*    <div*/}
                    {/*        className={classNames(*/}
                    {/*            style.card,*/}
                    {/*            style["chapter"]*/}
                    {/*        )}>*/}
                    {/*        <div className={style.title}>章节节点数</div>*/}
                    {/*        <div className={style.count}>*/}
                    {/*            {resourceData?.chapterCount}*/}
                    {/*            <span className={style.unit}>个</span>*/}
                    {/*        </div>*/}
                    {/*        <div className={style.Rows}>*/}
                    {/*            视频*/}
                    {/*            <span className={style.green}>*/}
                    {/*                {" "}*/}
                    {/*                {resourceData?.chapterVideoCount}*/}
                    {/*            </span>*/}
                    {/*            个 &nbsp; 文档*/}
                    {/*            <span className={style.green}>*/}
                    {/*                {" "}*/}
                    {/*                {resourceData?.chapterDocumentCount}*/}
                    {/*            </span>*/}
                    {/*            个 &nbsp; 其他资料*/}
                    {/*            <span className={style.green}>*/}
                    {/*                {" "}*/}
                    {/*                {resourceData?.chapterOtherCount}*/}
                    {/*            </span>*/}
                    {/*            个*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*)}*/}
                    <div
                        className={classNames(style.card, style["courseware"])}>
                        <div className={style.title}>上传课件</div>
                        <div className={style.count}>
                            {resourceData?.coursewareTotalCount}
                            <span className={style.unit}>个</span>
                        </div>
                        <div className={style.detail}>
                            未发布课件
                            <span className={style.blue}>
                                {" "}
                                {resourceData?.coursewareUnPublishCount}
                            </span>
                            个&nbsp; 已发布课件
                            <span className={style.blue}>
                                {" "}
                                {resourceData?.coursewarePublishCount}
                            </span>
                            个
                        </div>
                    </div>

                    <div className={classNames(style.card, style["questions"])}>
                        <div className={style.title}>发布题目</div>
                        <div className={style.count}>
                            {resourceData?.topicCount}
                            <span className={style.unit}>个</span>
                        </div>
                        <div className={style.detail}>
                            客观题目
                            <span className={style.yellow}>
                                {" "}
                                {resourceData?.objectiveCount}
                            </span>
                            个&nbsp; 主观题目
                            <span className={style.yellow}>
                                {" "}
                                {resourceData?.subjectiveCount}
                            </span>
                            个
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
